import { PROCESSING_TASK } from "./const.js";
export const _handleMouseDownOnSelectorPathEl = (self, event) => {
  const selection_translate_transform =
    self._getSelectionTranslateTransformThrowable();
  const selection = self._getSelectionThrowable();
  const { clientX: x, clientY: y } = event;
  const point = self._toViewPortPoint({
    x,
    y,
  });
  selection_translate_transform.start({
    x: point.x,
    y: point.y,
    els: [...selection.getSelectedEls()],
  });
  self._processing_task = PROCESSING_TASK.TRANSLATE_TRANSFORMING;
};
